/**
 * Normalizes a URL by removing duplicate slashes in the path.
 * Preserves the double slash after the protocol (http:// or https://).
 *
 * @example
 * normalizeUrl('https://example.com//path//to//resource')
 * // Returns: 'https://example.com/path/to/resource'
 */
export const normalizeUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;

  return url.replace(/([^:]\/)\/+/g, '$1');
};
